'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = jQuery;
var $document = $(document);
var CustomOSMProvider = require('../../osm-provider');
var MapService = require('./map-service.js');
var GeocodingResult = require('../geocoding-result.js');
var utils = require('../utils.js');

var LeafletOSMMapService = function (_MapService) {
	_inherits(LeafletOSMMapService, _MapService);

	function LeafletOSMMapService($canvas, settings) {
		_classCallCheck(this, LeafletOSMMapService);

		var _this2 = _possibleConstructorReturn(this, (LeafletOSMMapService.__proto__ || Object.getPrototypeOf(LeafletOSMMapService)).call(this, $canvas, settings));

		_this2.layers = {
			'road': [L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				minZoom: 2,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
			})],
			'terrain': [L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
				minZoom: 2,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
			})],

			'grayscale': [L.tileLayer('https://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
				minZoom: 2,
				maxZoom: 18,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
			})],
			'watercolor': [L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.{ext}', {
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
				subdomains: 'abcd',
				minZoom: 2,
				maxZoom: 16,
				ext: 'png'
			})],
			'ink': [L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.{ext}', {
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
				subdomains: 'abcd',
				minZoom: 2,
				maxZoom: 20,
				ext: 'png'
			})],
			'pastel': [L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
				minZoom: 2,
				maxZoom: 19,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
			})],

			'image': [L.tileLayer(settings.map.tileset + 'z{z}-tile_{y}_{x}.png', {
				minZoom: 0,
				maxZoom: 4,
				noWrap: true
			})]
		};
		_this2.settings = settings;
		_this2.markers = [];
		_this2.cluster = L.markerClusterGroup();
		_this2.geocoder = new CustomOSMProvider();
		_this2.$canvas = $canvas;

		_this2.worldBounds = [[-85, -180], // Southwest coordinates
		[85, 180] // Northeast coordinates
		];
		_this2.type = null;

		_this2.map = L.map(_this2.$canvas.get(0), {
			'attributionControl': false,
			'zoomControl': false,
			'doubleClickZoom': false,
			'scrollWheelZoom': _this2.settings.zoom.enabled,
			'attribution': '',
			'maxBoundsViscosity': 0.9
		});

		_this2.map.on('dblclick', function (e) {
			return $(_this2).trigger('dblclick', e.latlng);
		});

		_this2.map.addLayer(_this2.cluster);

		_this2.markersContainer = _this2.settings.cluster.enabled ? _this2.cluster : _this2.map;

		_this2.StealthLocateControl = L.Control.Locate.extend({
			onAdd: function onAdd(m) {
				// do not render a button
				this._layer = this.options.layer || L.layerGroup();
				this._layer.addTo(m);
				this._event = undefined;
				this._prevBounds = null;

				var container = L.DomUtil.create('div');
				var linkAndIcon = this.options.createButtonCallback(container, this.options);
				this._link = linkAndIcon.link;
				this._icon = linkAndIcon.icon;

				this._resetVariables();

				this._map.on('unload', this._unload, this);

				return container;
			}
		});

		_this2.attributionControl = L.control.attribution({
			prefix: false,
			position: 'bottomleft'
		});
		_this2.map.addControl(_this2.attributionControl);

		_this2.locateControl = new _this2.StealthLocateControl({
			icon: 'icon-null-class',
			iconLoading: 'icon-loading-null-class'
		});
		_this2.locateControl.addTo(_this2.map);

		_this2.$canvas.css({
			'background': _this2.settings.map.background
		});
		return _this2;
	}

	_createClass(LeafletOSMMapService, [{
		key: 'setType',
		value: function setType(type) {
			var _this3 = this;

			for (var layerType in this.layers) {
				var layerGroup = this.layers[layerType];
				for (var i = 0; i < layerGroup.length; i++) {
					this.map.removeLayer(layerGroup[i]);
				}
			}

			for (var i = 0; i < this.layers[type].length; i++) {
				this.map.addLayer(this.layers[type][i]);
			}

			this.type = type;
			setTimeout(function () {
				if (type === 'image') {
					_this3.map.setMaxBounds(null);
				} else {
					_this3.map.setMaxBounds(_this3.worldBounds);
				}
			}, 0);
		}
	}, {
		key: 'getCenter',
		value: function getCenter() {
			return this.map.getCenter();
		}
	}, {
		key: 'setCenter',
		value: function setCenter(center) {
			var _this = this;
			return new Promise(function (resolve, reject) {
				_this.map.once('moveend', resolve);
				_this.map.panTo(center, {
					reset: true,
					animate: false,
					noMoveStart: true
				});
			});
		}
	}, {
		key: 'setZoom',
		value: function setZoom(zoom) {
			var _this = this;
			return new Promise(function (resolve, reject) {
				if (_this.map.getZoom() === zoom) {
					resolve();
					return;
				}
				_this.map.once('zoomend', resolve);
				_this.map.setZoom(zoom, {
					reset: true,
					animate: false
				});
			});
		}
	}, {
		key: 'getZoom',
		value: function getZoom() {
			return this.map.getZoom();
		}
	}, {
		key: 'addPinWithIcon',
		value: function addPinWithIcon(pin, icon) {
			var _this = this;
			var markerOptions = {
				'draggable': false,
				'riseOnHover': true
			};
			if (icon) {
				markerOptions.icon = icon;
			}
			if (pin.model.animatePinpoints && !this.settings.cluster.enabled) {
				markerOptions.bounceOnAdd = true;
			}
			var marker = L.marker(pin.model.latlng, markerOptions);
			marker._Mapify = pin;
			if (pin.isVisible()) {
				this.markersContainer.addLayer(marker);
			}
			this.markers.push(marker);

			// Events
			marker.on('mouseover', function (e) {
				var pin = this._Mapify;
				pin.mouseover = true;
				setTimeout(function () {
					pin.mouseover = false;
				});
				_this.showMarkerTooltip(this);
			});

			marker.on('mouseout', function (e) {
				var pin = this._Mapify;
				var tooltip = pin.tooltip;
				if (!tooltip) {
					return;
				}
				tooltip.node().trigger({
					'type': 'tooltip_mouseout'
				});
			});

			marker.on('click', function (e) {
				var marker = this;
				var pin = marker._Mapify;
				var tooltip = pin.tooltip;

				var hover = function hover() {
					_this.showMarkerTooltip(marker);
				};

				var click = function click() {
					$document.trigger('mapify.action.openPopup', {
						value: pin.model.id
					});
				};

				if (tooltip && !tooltip.node().is(':visible')) {
					hover();
					return;
				}
				click();
			});

			if (pin.tooltip) {
				this.map.on('movestart', function () {
					pin.tooltip.hide();
				});
				this.map.on('moveend', function () {
					pin.tooltip.hide();
				});
				this.map.on('zoomstart', function () {
					pin.tooltip.hide();
				});
				this.map.on('zoomend', function () {
					pin.tooltip.hide();
				});
				this.map.on('viewreset', function () {
					pin.tooltip.hide();
				});
			}
		}
	}, {
		key: 'addPin',
		value: function addPin(pin) {
			var _this = this;

			return new Promise(function (resolve, reject) {
				var onImageLoaded = function onImageLoaded() {
					var width = pin.model.image.size ? pin.model.image.size[0] : 0;
					var height = pin.model.image.size ? pin.model.image.size[1] : 0;
					if (!width) {
						width = pin.image.width;
						height = pin.image.height;
					}

					var icon = L.icon({
						'iconUrl': pin.model.image.url,
						'iconAnchor': [width / 2, height]
					});
					_this.addPinWithIcon(pin, icon);
					resolve();
				};

				if (pin.model.image.url) {
					if (pin.image.complete) {
						onImageLoaded();
					} else {
						pin.image.onload = onImageLoaded;
						pin.image.onLoad = pin.image.onload;
					}
				} else {
					_this.addPinWithIcon(pin, null);
					resolve();
				}
			});
		}
	}, {
		key: 'addPins',
		value: function addPins(pins) {
			var promises = [];
			for (var i = 0; i < pins.length; i++) {
				var pin = pins[i];
				promises.push(this.addPin(pin));
			}
			return Promise.all(promises);
		}
	}, {
		key: 'showTooltip',
		value: function showTooltip(tooltip, latLng, anchor) {
			var $win = $(window);
			if (tooltip.node().is(':visible')) {
				return false;
			}

			var containerPoint = this.map.latLngToContainerPoint(latLng);
			var left = this.$canvas.offset().left + containerPoint.x - Math.ceil(tooltip.node().width() / 2) + anchor[0];
			var top = this.$canvas.offset().top + containerPoint.y - tooltip.node().height() + anchor[1];

			if ($win.width() >= 767 && tooltip.node().hasClass('mpfy-tooltip-image-orientation-left') && tooltip.node().hasClass('mpfy-tooltip-with-thumbnail')) {
				var left = this.$canvas.offset().left + containerPoint.x - Math.ceil(tooltip.node().width() / 2 - 61) + anchor[0];
			};

			setTimeout(function () {
				tooltip.node().trigger({
					'type': 'tooltip_mouseover',
					'settings': {
						'left': left,
						'top': top
					}
				});
			}, 100);
		}
	}, {
		key: 'showMarkerTooltip',
		value: function showMarkerTooltip(marker) {
			var _this = this;
			var latLng = marker.getLatLng();
			var pin = marker._Mapify;
			var tooltip = pin.tooltip;

			if (!tooltip) {
				return;
			}

			var anchor = [0, -10];
			if (pin.model.image.url) {
				if (pin.model.image.anchor[1] > 0) {
					anchor[1] -= pin.model.image.anchor[1];
				} else {
					anchor[1] -= pin.image.height;
				}
			} else {
				anchor[1] = -50; // default pin height
			}

			if (utils.isPhone()) {
				// offset the position slightly so that the map is centered lower so there is more vertical space for the tooltip on mobile

				var targetPoint = _this.map.project(latLng, _this.getZoom());
				var targetLatLng = _this.map.unproject(targetPoint.add(L.point([0, -128])));

				_this.setCenter(targetLatLng).then(function () {
					_this.showTooltip(tooltip, latLng, anchor);
				});
			} else {
				_this.showTooltip(tooltip, latLng, anchor);
			}
		}
	}, {
		key: 'geocode',
		value: function geocode(query) {
			var _this4 = this;

			var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			return this.geocoder.search({ query: query, country: country }).then(function (results) {
				if (results.length) {
					return results;
				}

				return _this4.geocoder.search({ query: '', postalcode: query, country: country });
			}).then(function (results) {
				if (results.length) {
					return results;
				}

				return _this4.geocoder.search({ query: query, postalcode: query, country: country });
			}).then(function (results) {
				var filteredResults = results.map(function (result) {
					return new GeocodingResult(result.label, result.y, result.x);
				});

				return filteredResults;
			});
		}
	}, {
		key: 'getPinsWithinRange',
		value: function getPinsWithinRange(lat, lng, rangeInMeters) {
			var target = [lat, lng];
			return this.markers.filter(function (marker) {
				var distance = marker.getLatLng().distanceTo(target);
				return distance <= rangeInMeters;
			}).map(function (marker) {
				return marker._Mapify;
			});
		}
	}, {
		key: 'getPinClosestTo',
		value: function getPinClosestTo(lat, lng) {
			var lowestDistance = -1;
			var closestPin = null;

			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				var distance = marker.getLatLng().distanceTo([lat, lng]);
				if (lowestDistance < 0 || distance < lowestDistance) {
					lowestDistance = distance;
					closestPin = marker._Mapify;
				}
			}
			return closestPin;
		}
	}, {
		key: 'getPinDistance',
		value: function getPinDistance(lat, lng, pin) {
			var marker = this.getPinMarker(pin);
			var distance = marker.getLatLng().distanceTo([lat, lng]);
			return distance;
		}
	}, {
		key: 'highlightPin',
		value: function highlightPin(pin) {
			var _this5 = this;

			var _this = this;
			var marker = this.getPinMarker(pin);
			if (!marker) {
				return Promise.resolve();
			}

			return Promise.resolve().then(function () {
				var promises = _this5.markers.map(function (marker) {
					var currentPin = marker._Mapify;
					currentPin.setVisibility('base', true);
					return _this.updatePinVisibility(currentPin);
				});

				return Promise.all(promises);
			}).then(function () {
				if (!_this.settings.cluster.enabled) {
					return Promise.resolve();
				}
				var zoomToLayer = Promise.promisify(_this.cluster.zoomToShowLayer, { context: _this.cluster });
				return zoomToLayer(marker);
			}).then(function () {
				return _this.setCenter(marker.getLatLng());
			}).then(function () {
				return _this.showMarkerTooltip(marker);
			});
		}
	}, {
		key: 'getPinMarker',
		value: function getPinMarker(pin) {
			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				if (marker._Mapify === pin) {
					return marker;
				}
			}
			return null;
		}
	}, {
		key: 'fitPins',
		value: function fitPins(pins) {
			var _this = this;
			if (pins.length === 0) {
				return;
			}
			var latLngs = pins.map(function (pin) {
				return pin.model.latlng;
			});
			var bounds = L.latLngBounds(latLngs);

			return new Promise(function (resolve, reject) {
				_this.map.once('viewreset', resolve);
				_this.map.fitBounds(bounds, {
					reset: true,
					animate: false,
					noMoveStart: true,
					maxZoom: _this.map.getZoom(),
					padding: [50, 50]
				});
			});
		}
	}, {
		key: 'updatePinVisibility',
		value: function updatePinVisibility(pin) {
			var _this = this;
			var marker = _this.getPinMarker(pin);
			if (!marker) {
				return;
			}

			return new Promise(function (resolve, reject) {
				if (pin.isVisible()) {
					if (!_this.markersContainer.hasLayer(marker)) {
						// For some reason addLayer causes the marker to change it's LatLng
						// so we buffer it and reapply it
						var markerLatLng = marker.getLatLng();

						_this.markersContainer.on('layeradd', resolve);
						_this.markersContainer.addLayer(marker);
						marker.setLatLng(markerLatLng);
						return;
					}
				} else {
					if (_this.markersContainer.hasLayer(marker)) {
						_this.markersContainer.on('layerremove', resolve);
						_this.markersContainer.removeLayer(marker);
						return;
					}
				}
				resolve();
			});
		}
	}, {
		key: 'locate',
		value: function locate() {
			var _this6 = this;

			return new Promise(function (resolve, reject) {
				_this6.map.once('locationfound', resolve);
				_this6.map.once('locationerror', reject);
				_this6.locateControl._onClick();
			});
		}
	}, {
		key: 'redraw',
		value: function redraw() {
			this.map._onResize();
		}
	}]);

	return LeafletOSMMapService;
}(MapService);

;

module.exports = LeafletOSMMapService;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map-services/leaflet-osm-map-service.js
// module id = 17
// module chunks = 0